// types
import { TransactionStatus, TraceabilityTransaction } from '../../../@types';

// mui
import { Box, Grid } from '@mui/material';

// ui
import { ChipStatus } from '../ChipStatus/ChipStatus';
import { ChipTraceability } from '../ChipTraceability/ChipTraceability';

// props
export interface ChipStatusTraceabilityProps {
	status: TransactionStatus;
	traceability: TraceabilityTransaction;
}

export const ChipStatusTraceability = ({ status, traceability }: ChipStatusTraceabilityProps) => {
	return (
		<Box>
			<Grid container direction="column" spacing={1}>
				<Grid item>
					<ChipTraceability traceability={traceability} />
				</Grid>
				<Grid item>
					<ChipStatus status={status} />
				</Grid>
			</Grid>
		</Box>
	);
};
